import type { Role } from "./api.js";

/**
 * Single source of truth for where a freshly-authenticated user lands.
 *
 * Everyone lands on the dashboard hub — its CONTENT adapts by role (creators get capture
 * quick-create + 作業中, viewers get their 本棚 + 続きから, managers get KPIs + 承認).
 * The old capture-only 作成者ホーム is retired.
 */
export function defaultRouteForRoles(_roles: Role[]): string {
  return "/dashboard";
}
